import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { formatRut } from "../lib/format";

// Ruta pública "/activar": el apoderado registra su correo probando identidad
// con el RUT y la fecha de nacimiento del alumno, y obtiene acceso inmediato.
export function ActivarCuenta() {
  const { activarApoderado } = useAuth();
  const [rut, setRut] = useState("");
  const [fnac, setFnac] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await activarApoderado(rut, fnac, email);
      // Al iniciar sesión, App redirige al portal automáticamente.
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="grid min-h-screen place-items-center bg-gradient-to-br from-brand-50 via-slate-50 to-white p-4">
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-3 grid h-14 w-14 place-items-center rounded-2xl bg-brand-600 text-2xl">🏐</div>
          <h1 className="text-2xl font-extrabold text-slate-800">Activa tu cuenta</h1>
          <p className="text-sm text-slate-500">Registra tu correo para ver las cuotas de tu hijo/a</p>
        </div>

        <div className="card p-6">
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="label">RUT del alumno</label>
              <input className="input" placeholder="12.345.678-9" value={rut}
                onChange={(e) => setRut(formatRut(e.target.value))} required />
            </div>
            <div>
              <label className="label">Fecha de nacimiento del alumno</label>
              <input className="input" type="date" value={fnac} onChange={(e) => setFnac(e.target.value)} required />
            </div>
            <div>
              <label className="label">Tu correo (apoderado)</label>
              <input className="input" type="email" placeholder="correo@mail.com" value={email}
                onChange={(e) => setEmail(e.target.value)} required />
            </div>

            {error && <p className="rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-600">{error}</p>}

            <button className="btn-primary w-full" disabled={busy}>
              {busy ? "Activando…" : "Activar y entrar"}
            </button>
          </form>
        </div>

        <p className="mt-4 text-center text-xs text-slate-400">
          ¿Ya activaste tu cuenta? <Link to="/" className="font-semibold text-brand-600 hover:underline">Ir al inicio</Link>
        </p>
        <p className="mt-1 text-center text-xs text-slate-400">
          Usamos la fecha de nacimiento solo para confirmar tu identidad.
        </p>
      </div>
    </div>
  );
}
